import React, { useEffect } from 'react'
import { createTheme, MantineProvider, LoadingOverlay } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'
import { Routes, Route } from "react-router-dom"
import { routes, authRoutes } from './routes'
import { useLocalStorage, readLocalStorageValue, useHotkeys } from '@mantine/hooks'
import { getCredential } from './store/authData'
import { getAuthUserLogin } from './store/userLogin'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Cookies from "universal-cookie"

// css mantine
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/charts/styles.css'

// css ck-editor
import 'ckeditor5/ckeditor5.css'
// custom css font ck-editor
import './assets/module-css/ck-editor-custom.css'

export default function App() {
  const cookies = new Cookies()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { isLoading, isLogin } = useSelector(state => state.auth)
  const themeValue = readLocalStorageValue({ key: 'manage-app-theme' })
  const layoutValue = readLocalStorageValue({ key: 'manage-app-layout' })
  const [, setThemeApp] = useLocalStorage({
    key: 'manage-app-theme',
    defaultValue: themeValue ? themeValue : 'light'
  })

  const [, setLayout] = useLocalStorage({
    key: 'manage-app-layout',
    defaultValue: layoutValue ? layoutValue : 'nav-header'
  })

  const defaultPrimaryColor = ["#ffe9ee", "#fed2d9", "#f8a3b1", "#f37186", "#ee4761", "#ec2d4a", "#ec1e3e", "#d21130", "#bc072a", "#a50022"]

  const styleUI = createTheme({
    primaryColor: 'red',
    colors: {
      'red': defaultPrimaryColor
    },
    fontFamily: "Inter, serif",
    headings: {
      fontFamily: 'Inter, serif'
    }
  })

  const handleChangeTheme = () => {
    setThemeApp((current) => current === 'dark' ? 'light' : 'dark')
  }

  // shortcut hotkeys theme 
  useHotkeys([
    ['mod+J', () => handleChangeTheme()]
  ])

  // update credential
  useEffect(() => {
    dispatch(getCredential())
    setLayout((current) => current === 'nav-sidebar' ? 'nav-sidebar' : 'nav-header')
  }, [dispatch, setLayout])

  // init load page to top page
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])


  useEffect(() => {
    if (!isLoading) {
      if (isLogin) {
        dispatch(getAuthUserLogin())
        // return <Navigate to={pathname !== '/login' ? pathname : '/dashboard'} replace />
        return navigate(pathname === '/login' ? '/dashboard' : pathname + search)
      } else {
        cookies.remove('manage-session')
        cookies.remove('authData')
        return navigate('/login', { replace: true })
      }
    }
    // eslint-disable-next-line
  }, [isLoading, isLogin])

  // eslint-disable-next-line
  const getRoute = (allRoutes) => allRoutes.map((page) => {
    if (!page.hasChildren) {
      return (
        <Route path={page.route} element={page.component} key={page.name} />
      )
    } else {
      return (
        <Route path={page.route} key={page.name}>
          {childrenRoute(page.children)}
        </Route>
      )
    }
  })

  // eslint-disable-next-line
  const childrenRoute = (arrayRoute) => arrayRoute.map((children) => {
    if (children) {
      if (children.route === null) {
        return (
          <Route index element={children.component} key={children.name} />
        )
      } else {
        return (
          <Route path={children.route} element={children.component} key={children.name} />
        )
      }
    }
  })

  return (
    <MantineProvider forceColorScheme={themeValue} theme={styleUI}>
      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: "md", blur: 3 }} />
      <Notifications autoClose={3000} position="top-right" limit={5} />
      <ModalsProvider>
        <Routes>
          {getRoute(routes)}
          {getRoute(authRoutes)}
        </Routes>
      </ModalsProvider>
    </MantineProvider>
  )
}

